import { Directive, ElementRef, Input, Renderer2, inject } from '@angular/core';

@Directive({
  selector: '[scrollItemIntoView]',
  standalone: true,
})
export class ScrollItemIntoViewDirective {
  @Input('scrollItemIntoView') public itemId: string;
  private _eleRef = inject(ElementRef<HTMLElement>);
  private _renderer = inject(Renderer2);

  private _formLayout = '';
  public get formLayout() {
    let localStorageFormLayout = localStorage.getItem('FormLayout');
    return (this._formLayout = localStorageFormLayout ?? '');
  }

  constructor() {}

  public getScrolledIntoView() {
    this._eleRef.nativeElement.scrollIntoView({
      behavior: 'smooth',
      block: 'nearest',
    });
    if (this.formLayout?.toLowerCase() === 'multiple') {

      this._renderer.setStyle(
        this._eleRef.nativeElement,
        'background',
        'gainsboro',
      );
      this._renderer.setStyle(
        this._eleRef.nativeElement,
        'transition',
        'background-color 0.75s linear',
      );
      setTimeout(() => {

        this._renderer.setStyle(
          this._eleRef.nativeElement,
          'background',
          'transparent',
        );
        this._renderer.setStyle(
          this._eleRef.nativeElement,
          'transition',
          'background-color 0.75s linear',
        );
      }, 1000);
    }
  }
}
